<!--  -->
<template>
    <div>
        <van-action-sheet v-model="showSexPick">
            <div class="content">
                <van-picker title="选择性别" show-toolbar value-key="name" :columns="sexList" @confirm="onConfirm" @cancel="onCancel" @change="onChange" />
            </div>
        </van-action-sheet>
    </div>
</template>

<script>
import { Picker } from "vant";

export default {
    name: "sexPicker",
    components: {
        "van-picker": Picker,
    },
    props: {
        showSexPick: {
            type: Boolean,
            default: false,
        },
        sex: {
            type: Object,
        },
    },
    data() {
        return {
            sexList: [
                { name: "男", value: 1 },
                { name: "女", value: 2 },
            ],
        };
    },

    computed: {},

    mounted() {},

    methods: {
        onConfirm(item) {
            this.$emit("update", item);
            this.$emit("update:showSexPick", false);
        },
        onCancel() {
            this.$emit("update:showSexPick", false);
        },
        onChange() {},
    },
};
</script>
<style></style>
